export const productHasStock = ({ stock }) => stock > 0;
export const shouldShowStrikethroughPrice = (strikethroughPrice, specialPrice) => Number.isFinite(strikethroughPrice) && Number.isFinite(specialPrice) && strikethroughPrice > specialPrice;
